export default __webpack_public_path__ + "static/chatBot-90055f029dda020a5a9d6a484ad4b46f.png";